import { SUGGESTION_MODE_LABELS, type UserMessage } from '@/chat/types';
import { Attachment, AttachmentPreview, Attachments } from '@/components/ai-elements/attachments';
import { Message, MessageContent } from '@/components/ai-elements/message';

export const UserBubble = ({ message }: { message: UserMessage }) => {
  const modeLabel = message.mode !== 'auto' ? SUGGESTION_MODE_LABELS[message.mode] : null;
  const tags = [
    message.type === 'replacement' && '음원 교체',
    message.isStoryboard && '스토리보드',
    modeLabel,
  ].filter(Boolean);

  return (
    <Message from="user">
      {message.attachment && (
        <Attachments variant="grid">
          <Attachment data={{ ...message.attachment, id: message.id }}>
            <AttachmentPreview />
          </Attachment>
        </Attachments>
      )}
      {tags.length > 0 && (
        <span className="text-muted-foreground ml-auto text-xs">{tags.join(' · ')}</span>
      )}
      {message.text && (
        <MessageContent className="whitespace-pre-wrap">{message.text}</MessageContent>
      )}
    </Message>
  );
};
